import styled from 'styled-components';

export const ContainerMain = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-left: 2.2rem;
  padding-right: 2.2rem;
`;
